import { gql } from '@apollo/client';

export const CREATE_AGENCY_BY_SUPERADMIN = gql`
  mutation CreateAgencyBySuperAdmin(
    $email: String!
    $password: String!
    $role: String!
    $agencyName: String!
    $subdomain: String!
    $domainType: String!
  ) {
    createAgencyBySuperAdmin(
      email: $email
      password: $password
      role: $role
      agencyName: $agencyName
      subdomain: $subdomain
      domainType: $domainType
    ) {
      user {
        id
        email
        role
        agencyName
        agency {
          id
          name
          subdomain
          domainType
        }
      }
      token
    }
  }
`;

export const UPDATE_AGENCY_BY_SUPERADMIN = gql`
  mutation UpdateAgencyBySuperAdmin($agencyId: Int!, $input: AgencyInput!, $mainUserRole: String) {
    updateAgencyBySuperAdmin(agencyId: $agencyId, input: $input, mainUserRole: $mainUserRole) {
      id
      name
      subdomain
      domainType
      email
      phone
      address
      website
      description
      firstTitle
      secondTitle
      logo
      imageCover
      aboutImage
      facebook
      instagram
      tiktok
      yearsExperience
      expertise
      satisfiedTravelers
      prestations
      theme {
        primaryColor
        secondaryColor
        accentColor
        textColor
        backgroundColor
        headerStyle
        font
        heroTextColor
      }
      popularDestinations {
        id
        name
        image
        price
      }
    }
  }
`;

export const DELETE_AGENCY = gql`
  mutation DeleteAgency($id: Int!) {
    deleteAgency(id: $id) {
      id
      success
    }
  }
`;
